import { Col, Row } from 'antd'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { BlockWrapper, BynderPicture, Container, CTALink, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


DetailCard.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.object,
    text: PropTypes.string,
    cta_link_caption: PropTypes.string,
    cta_link: PropTypes.string,
    cta_link_type: PropTypes.string,
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
  }),
  priorityLoad: PropTypes.bool.isRequired,
}

export default function DetailCard({
  data = {},
  priorityLoad,
}) {
  const image = get(data, 'image', {})
  return (
    <BlockWrapper>
      <Container size="xl">
        <Row className={classNames.container}>
          <Col span={24} md={14} className={classNames.imageContainer}>
            <BynderPicture
              image={image}
              priority={priorityLoad}
              mobileImage={{
                maxWidth: 800,
                maxHeight: 400,
                sizes: '100vw',
              }}
              desktopImage={{
                maxWidth: 800,
                maxHeight: 500,
                sizes: '70vw',
              }}
            />
          </Col>
          <Col span={24} md={10} className={classNames.card}>
            {data.heading && (
              <Typography
                variant="h4"
                tag={data.heading_hx}
                color="black"
                transform="uppercase"
                className={classNames.heading}
              >
                {data.heading}
              </Typography>
            )}
            <Typography
              variant="content"
              color="black"
              tag="p"
              className={classNames.cardText}
            >
              {data.text}
            </Typography>
            <CTALink
              cta={data.cta_link_caption}
              ctaURL={data.cta_link}
              type={data.cta_link_type}
              icon="chevron-right"
              className={classNames.cta}
            />
          </Col>
        </Row>
      </Container>
    </BlockWrapper>
  )
}
